import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-num",
  "use": "icon-num-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-num\"><defs><style type=\"text/css\"></style></defs><path d=\"M144.768 359.68l352.384 176.256a27.904 27.904 0 0 0 24.96 0L874.624 359.68a27.904 27.904 0 0 0 0-49.92L522.368 133.504a28.032 28.032 0 0 0-24.96 0L144.896 309.76a27.904 27.904 0 0 0 0 49.92z m74.752-24.96l290.176-145.024L800 334.72 509.696 479.744zM871.424 660.224a27.52 27.52 0 0 0-21.248 1.792L509.696 832 170.112 661.888h-1.536a27.904 27.904 0 0 0-23.68 51.2l352.256 175.36a27.904 27.904 0 0 0 24.96 0l352.384-176.64h1.536a27.904 27.904 0 0 0-4.48-51.2z\" p-id=\"4664\" /><path d=\"M144.768 535.936l352.384 176.256a27.904 27.904 0 0 0 24.96 0l352.256-176.384h1.536a27.904 27.904 0 0 0-25.6-49.408L510.592 655.872l-340.48-170.24h-1.536a27.904 27.904 0 0 0-23.68 51.2z\" p-id=\"4665\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/num.svg
// module id = 1049
// module chunks = 36